var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.97918 1.37508C0.97918 0.983879 1.29631 0.666748 1.68751 0.666748H29.312C29.7032 0.666748 30.0203 0.98388 30.0203 1.37508V4.23493C30.0203 4.62613 29.7032 4.94326 29.312 4.94326H1.68751C1.29631 4.94326 0.97918 4.62613 0.97918 4.23493V1.37508ZM1.68768 8.36436C1.29648 8.36436 0.97935 8.68149 0.97935 9.07269V11.9325C0.97935 12.3237 1.29648 12.6409 1.68768 12.6409H24.6143C25.0055 12.6409 25.3227 12.3237 25.3227 11.9325V9.07269C25.3227 8.68149 25.0055 8.36436 24.6143 8.36436H1.68768ZM29.3109 9.2191C29.7021 9.2191 30.0193 9.53623 30.0193 9.92744V12.7873C30.0193 13.1785 29.7021 13.4956 29.3109 13.4956H26.4568C26.0656 13.4956 25.7485 13.1785 25.7485 12.7873V9.92744C25.7485 9.53623 26.0656 9.2191 26.4568 9.2191H29.3109ZM4.54143 16.9181C4.93263 16.9181 5.24976 17.2353 5.24976 17.6265V20.4863C5.24976 20.8775 4.93263 21.1947 4.54143 21.1947H1.68734C1.29614 21.1947 0.979004 20.8775 0.979004 20.4863V17.6265C0.979004 17.2353 1.29614 16.9181 1.68734 16.9181H4.54143ZM9.23829 19.057C9.62949 19.057 9.94662 19.3741 9.94662 19.7653V22.6252C9.94662 23.0164 9.62949 23.3335 9.23829 23.3335H6.3842C5.993 23.3335 5.67587 23.0164 5.67587 22.6252V19.7653C5.67587 19.3741 5.993 19.057 6.3842 19.057H9.23829ZM10.3748 17.6265C10.3748 17.2353 10.6919 16.9181 11.0831 16.9181H29.3119C29.7031 16.9181 30.0203 17.2353 30.0203 17.6265V20.4863C30.0203 20.8775 29.7031 21.1947 29.3119 21.1947H11.0831C10.6919 21.1947 10.3748 20.8775 10.3748 20.4863V17.6265Z",
    fill: "url(#paint0_radial_1_18535)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_18535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.48701 26.3403) rotate(-16.3464) scale(50.952 468.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#1157ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#1164E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16EBC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.dc0547110ed2598633a3ab62fe2eb056.svg";
export { ForwardRef as ReactComponent };